<template>
  <div>
    <div class="box">
      <div class="cus-1">
        <div class="orderMain">
          <div class="orderBox">
            <div class="orderItem orderItem1">
              <img
                src="../assets/img/centerIonc1.png"
                class="imgs"
                alt=""
                srcset=""
                @click="toAdd"
              />
              <div class="content" @click="toAdd">
                <p class="nums">{{ workNum.newAdd }}</p>
                <p class="name">新建工单</p>
              </div>
            </div>
            <div class="orderItem orderItem2" @click="toSend">
              <img
                src="../assets/img/centerIonc2.png"
                class="imgs"
                alt=""
                srcset=""
              />
              <div class="content">
                <p class="nums">{{ workNum.sendNum }}</p>
                <p class="name">待派发工单量</p>
              </div>
            </div>
            <div class="orderItem orderItem3" @click="toOperate">
              <img
                src="../assets/img/centerIonc3.png"
                class="imgs"
                alt=""
                srcset=""
              />
              <div class="content">
                <p class="nums">{{ workNum.handleNum }}</p>
                <p class="name">待处理工单量</p>
              </div>
            </div>
          </div>
          <div class="orderBox">
            <div class="orderItem orderItem4" @click="toVisited">
              <img
                src="../assets/img/centerIonc4.png"
                class="imgs"
                alt=""
                srcset=""
              />
              <div class="content">
                <p class="nums">{{ workNum.visiteNum }}</p>
                <p class="name">待回访工单量</p>
              </div>
            </div>
            <div class="orderItem orderItem5" @click="toDel">
              <img
                src="../assets/img/centerIonc5.png"
                class="imgs"
                alt=""
                srcset=""
              />
              <div class="content">
                <p class="nums">{{ workNum.delNum }}</p>
                <p class="name">待作废工单量</p>
              </div>
            </div>
            <div class="orderItem orderItem6" @click="toDel">
              <img
                src="../assets/img/centerIonc6.png"
                class="imgs"
                alt=""
                srcset=""
              />
              <div class="content">
                <p class="nums">{{ workNum.netNum }}</p>
                <p class="name">虚假工单量</p>
              </div>
            </div>
          </div>
        </div>
        <div class="operationBox">
          <div class="operateTitle">
            <span>个人工作总结</span>
            <p class="operateChoose">
              <span
                :class="{ 'active-text': peronIndex == 1 }"
                @click="personTap('1')"
              >
                本日
              </span>
              <span
                :class="{ 'active-text': peronIndex == 2 }"
                @click="personTap('2')"
              >
                本月
              </span>
              <span
                :class="{ 'active-text': peronIndex == 3 }"
                @click="personTap('3')"
              >
                本年
              </span>
            </p>
          </div>
          <div class="operationMain">
            <div class="operaItem operaHeader">
              <p class="name">类型</p>
              <p class="nums">次数</p>
              <p class="name">排名</p>
              <div class="see">总目标</div>
            </div>
            <div class="operaContent">
              <div class="operaItem operaItem1">
                <p class="name">呼入量</p>
                <p class="nums">{{ statisData.callIn }}次</p>
                <span class="seeInfo" @click="maksTap(0)">查看排名</span>
                <div class="see">
                  <span>今日目标：</span>
                  <span class="tip" v-if="isInCall == false">***</span>
                  <span class="tips" v-else>{{ targetInfo.callIn }}</span>
                  <img
                    src="../assets/img/hide.png"
                    class="seeShow"
                    alt=""
                    v-if="isInCall == false"
                    @click="inCallTap"
                  />
                  <img
                    v-else
                    src="../assets/img/see.png"
                    class="seeHide"
                    alt=""
                    @click="inCallTap"
                  />
                </div>
              </div>
              <div class="operaItem operaItem2">
                <p class="name">呼出量</p>
                <p class="nums">{{ statisData.callOut }}</p>
                <span class="seeInfo" @click="maksTap(1)">查看详情</span>
                <div class="see">
                  <span>今日目标：</span>
                  <span class="tip" v-if="isOutCall == false">***</span>
                  <span class="tips" v-else>{{ targetInfo.callOut }}</span>
                  <img
                    src="../assets/img/hide.png"
                    class="seeShow"
                    alt=""
                    v-if="isOutCall == false"
                    @click="outCallTap"
                  />
                  <img
                    v-else
                    src="../assets/img/see.png"
                    class="seeHide"
                    alt=""
                    @click="outCallTap"
                  />
                </div>
              </div>
              <div class="operaItem operaItem3">
                <p class="name">通话记录</p>
                <p class="nums">{{ statisData.totalCount }}</p>
                <span class="seeInfo" @click="maksTap(2)">查看详情</span>
                <div class="see">
                  <span>今日目标：</span>
                  <span class="tip" v-if="isRecond == false">***</span>
                  <span class="tips" v-else>{{ targetInfo.callLog }}</span>
                  <img
                    src="../assets/img/hide.png"
                    class="seeShow"
                    alt=""
                    v-if="isRecond == false"
                    @click="recondTap"
                  />
                  <img
                    v-else
                    src="../assets/img/see.png"
                    class="seeHide"
                    alt=""
                    @click="recondTap"
                  />
                </div>
              </div>
              <div class="operaItem operaItem4">
                <p class="name">派发工单量</p>
                <p class="nums">{{ statisData.paifa }}</p>
                <span class="seeInfo" @click="maksTap(3)">查看详情</span>
                <div class="see">
                  <span>今日目标：</span>
                  <span class="tip" v-if="isSend == false">***</span>
                  <span class="tips" v-else>{{ targetInfo.handOut }}</span>
                  <img
                    src="../assets/img/hide.png"
                    class="seeShow"
                    alt=""
                    v-if="isSend == false"
                    @click="sendTap"
                  />
                  <img
                    v-else
                    src="../assets/img/see.png"
                    class="seeHide"
                    alt=""
                    @click="sendTap"
                  />
                </div>
              </div>
              <div class="operaItem operaItem5">
                <p class="name">回访量</p>
                <p class="nums">{{ statisData.huifang }}</p>
                <span class="seeInfo" @click="maksTap(4)">查看详情</span>
                <div class="see">
                  <span>今日目标：</span>
                  <span class="tip" v-if="isVisited == false">***</span>
                  <span class="tips" v-else>{{ targetInfo.retrunVisit }}</span>
                  <img
                    src="../assets/img/hide.png"
                    class="seeShow"
                    alt=""
                    v-if="isVisited == false"
                    @click="visitedTap"
                  />
                  <img
                    v-else
                    src="../assets/img/see.png"
                    class="seeHide"
                    alt=""
                    @click="visitedTap"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="majorMain">
        <div class="majorBox">
          <p class="majorTitle">
            <span>重要提醒<i class="dot" v-if="allState == false"></i></span>
          </p>
          <ul class="majorUl">
            <li
              class="majorLi"
              @click="majorTap(0)"
              :class="majorIndex == 0 ? 'cur' : ''"
            >
              <span class="name"
                >生日提醒
                <span
                  class="dot"
                  v-if="birdayState == false && birthdayList.length > 0"
                  >{{ birthdayList.length }}</span
                ></span
              >
            </li>
            <li
              class="majorLi"
              @click="majorTap(1)"
              :class="majorIndex == 1 ? 'cur' : ''"
            >
              <span class="name"
                >设备告警
                <span
                  class="dot"
                  v-if="policeState == false && policeList.length > 0"
                  >{{ policeList.length }}</span
                ></span
              >
            </li>
            <li
              class="majorLi"
              @click="majorTap(2)"
              :class="majorIndex == 2 ? 'cur' : ''"
            >
              <span class="name"
                >健康告警
                <span
                  class="dot"
                  v-if="healState == false && warnList.length > 0"
                  >{{ warnList.length }}</span
                ></span
              >
            </li>
            <li
              class="majorLi"
              @click="majorTap(3)"
              :class="majorIndex == 3 ? 'cur' : ''"
            >
              <span class="name"
                >质检回访
                <span
                  class="dot"
                  v-if="visiteState == false && trajectList.length > 0"
                  >{{ trajectList.length }}</span
                ></span
              >
            </li>
          </ul>
        </div>
        <div class="majorRight">
          <el-table
            v-show="majorIndex == 1"
            :data="policeList"
            ref="tables"
            tooltip-effect="dark"
            style="width: 100%"
            height="630px"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="customerName"
              label="姓名"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="type"
              label="告警类型"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-for="(item, index) in typeList" :key="index">
                  <span v-if="scope.row.type == item.id">{{ item.name }}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="alarmTime"
              label="告警时间"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="orgName"
              label="所属机构"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="DisposalStatus"
              label="是否处置"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ scope.row.disposalStatus == 1 ? "已处置" : "未处置" }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="操作"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span
                  v-if="scope.row.disposalStatus == 0"
                  class="operation-color"
                  @click="Handle('处置', scope.row)"
                  >处置</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-show="majorIndex == 0"
            :data="birthdayList"
            ref="tables"
            tooltip-effect="dark"
            style="width: 100%"
            height="630px"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="customerName"
              label="姓名"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="birthday"
              label="生日日期"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="发送"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <img
                  src="../assets/img/12.png"
                  class="callPhone"
                  @click="callPhone1(scope.row)"
                />
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-show="majorIndex == 2"
            :data="warnList"
            ref="tables"
            tooltip-effect="dark"
            style="width: 100%"
            height="630px"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="customerName"
              label="姓名"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="alarmTime"
              label="警告时间"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="alarmContent"
              label="预警内容"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="回访"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <img
                  @click="callPhone(scope.row.customerPhone)"
                  src="../assets/img/12.png"
                  class="callPhone"
                />
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-show="majorIndex == 3"
            :data="trajectList"
            ref="tables"
            tooltip-effect="dark"
            style="width: 100%"
            height="630px"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="customerName"
              label="姓名"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="servetypename"
              label="服务类别"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="回访"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <img
                  @click="toTraject(scope.row)"
                  src="../assets/img/12.png"
                  class="callPhone"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 弹窗详情 start -->
    <el-dialog
      :close-on-click-modal="false"
      title="排名详情"
      :visible.sync="maskState"
      width="800px"
      @close="closeDialog"
      append-to-body
    >
      <div class="query">
        <el-input
          v-model="query.name"
          placeholder="请输入姓名"
          clear
          class="queryInput"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询 </el-button>
      </div>
      <el-table
        :data="rankList"
        style="width: 100%"
        :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
      >
        <el-table-column prop="index" label="序号" width="100">
        </el-table-column>
        <el-table-column prop="date" label="排名"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
      </el-table>
      <div class="pagination_container">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
          :total="page.total"
          :current-page.sync="page.pageNo"
          :page-size="10"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- 弹窗详情 end -->
    <msg1
      v-show="dialogVisible == true"
      @close="Dialogclose"
      :infoList="infoList"
    ></msg1>
  </div>
</template>

<script>
import headLine from "../components/headline"
import msg1 from "@/components/msg1.vue"
import request from "@/utils/request.js"
import exportVue from "@/utils/exportVue"

export default {
  components: {
    headLine,
    msg1,
  },
  data() {
    return {
      query: { name: "" },
      importantTable: [],
      infoList: {},
      dialogVisible: false,
      workNum: {
        newAdd: 0,
        sendNum: 0,
        handleNum: 0,
        visiteNum: 0,
        delNum: 0,
        netNum: 0,
      },
      typeList: [
        { id: "1", name: "紧急按钮" },
        { id: "2", name: "门磁" },
        { id: "3", name: "烟感" },
        { id: "4", name: "燃气" },
        { id: "5", name: "水浸" },
        { id: "6", name: "红外" },
        { id: "7", name: "手环" },
        { id: "8", name: "床垫" },
        { id: "9", name: "血糖仪" },
        { id: "10", name: "颐养卡" },
        { id: "11", name: "血压计" },
        { id: "12", name: "智能门锁" },
      ],
      statisData: [],
      targetInfo: {
        callIn: 0,
        callOut: 0,
        callLog: 0,
        handOut: 0,
        retrunVisit: 0,
      },
      timeTitle: "",
      openNum: 0,
      maskState: false,
      page: { pageNo: 1, pageSize: 10, total: 0 },
      rankList: [],
      peronIndex: 1,
      isInCall: false,
      isOutCall: false,
      isRecond: false,
      isSend: false,
      isVisited: false,
      learnIndex: 0,
      majorIndex: 0,
      dataTime: "",
      birthdayList: [],
      policeList: [],
      warnList: [],
      dataIds: [],
      trajectList: [],
      equipList: [],
      birdayState: false,
      equipState: false,
      healState: false,
      visiteState: false,
      allState: false,
      policeState: false,
      firstname: "",
    }
  },
  created() {
    let now = new Date()
    let hour = now.getHours()
    if (hour < 8) {
      this.timeTitle = "凌晨好，注意休息！"
    } else if (hour < 12) {
      this.timeTitle = "早上好，新的一天开始了！"
    } else if (hour < 14) {
      this.timeTitle = "中午好，中午午休很重要！"
    } else if (hour < 18) {
      this.timeTitle = "下午好，今日工作很多！"
    } else if (hour < 24) {
      this.timeTitle = "晚上好，加班辛苦了！"
    }
    let curDate = new Date()
    let years = curDate.getFullYear()
    let month =
      curDate.getMonth() + 1 < 10
        ? "0" + (curDate.getMonth() + 1)
        : curDate.getMonth() + 1
    let day =
      curDate.getDate() < 10 ? "0" + curDate.getDate() : curDate.getDate()
    this.dataTime = years + "-" + month + "-" + day
    this.getGongDan()
    this.getTraject()
    this.getWarn()
    this.getBirthday()
    this.getPolice()
    this.getEquip()
    // 新建工单
    this.getAdd()
    this.personTap("1")
  //  this.getLearn(0) //学习培训
  },
  mounted() {
    if (sessionStorage.getItem("homeBirth")) {
      this.birdayState = true
    }
    if (sessionStorage.getItem("homePolice")) {
      this.policeState = true
    }
    if (sessionStorage.getItem("homeWarn")) {
      this.healState = true
    }
    if (sessionStorage.getItem("homeTraject")) {
      this.visiteState = true
    }
    if (sessionStorage.getItem("homeEquip")) {
      this.equipState = true
    }
    if (
      this.birdayState == true &&
      this.equipState == true &&
      this.healState == true &&
      this.visiteState == true &&
      this.policeState == true
    ) {
      this.allState = true
    }
    exportVue.$on("updatePhone", (data) => {
      if (data == true) {
        console.log("重新调用接口")
        this.getTraject()
        this.getWarn()
        this.getBirthday()
        this.getPolice()
        this.getEquip()
      }
    })
  },
  methods: {
    Handle(title, row) {
      this.infoList = row
      this.dialogVisible = true
      exportVue.$emit("infoList", this.infoList)
    },
    Dialogclose(data) {
      this.dialogVisible = data
      if (data == false) {
        this.getPolice()
      }
    },
    getAdd() {
      const self = this
      request({
        url: "/jjyl/servicePgd/info/findTodayCount",
        method: "POST",
        data: {},
      }).then((res) => {
        if (res.code == 200) {
          // console.log("详情")
          if (res.content) {
            this.workNum.newAdd = res.content[0].pgdTotal
          }
        }
      })
    },
    // 设备类型
    getEquip() {
      this.equipList = []
    },
    //递归获取当前机构数据
    chbehavior(arr, id) {
      let vm = this
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            vm.parentId = a.parentId //当前绑定机构父级id
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },
    // 质检回访
    getTraject() {
      request({
        url: "/rbac/admin/org/info/OrgTreelist",
        method: "POST",
        data: { isValid: 1 },
      }).then((res) => {
        if (res.code === 200) {
          //当前账号绑定的机构所有下级
          let treeList = []
          let lists = this.chbehavior(res.content, this.$store.state.info.orgId)
          if (!lists.children) {
            treeList.push({
              label: lists.label,
              orgId: lists.orgId,
            })
            lists = treeList //带同级本身的数据
          } else {
            treeList.push({
              label: lists.label,
              orgId: lists.orgId,
              children: lists.children,
            })
            lists = treeList //带同级本身的数据
          }
          //获取当前选择的机构所有下级id集合
          let childrenIdList = this.getChildrenId(lists)
          this.dataIds = childrenIdList
          this.dataIds.push(this.parentId) //追加父级id
          this.getDataList()
        }
      })
    },
    getChildrenId(arr) {
      let res = []
      ;(function deepId(arr) {
        for (let i = 0; i < arr.length; i++) {
          res.push(arr[i].orgId)
          if (arr[i].children) {
            deepId(arr[i].children)
          }
        }
      })(arr)
      return res
    },
    getDataList() {
      let params = {
        dataIds: this.dataIds,
        pageNo: 1,
        pageSize: -1,
        states: "2",
      }
      request({
        url: "/jjyl/admin/serviceManagement/info/findServicepgdEffect",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.trajectList = res.content.list == null ? [] : res.content.list
          } else {
            this.trajectList = []
          }
        }
      })
    },
    // 健康告警
    getWarn() {
      request({
        url: "/ypt/admin/customerHealthWarn/info/findList",
        method: "POST",
        data: { pageNo: 1, pageSize: -1 },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          // console.log(res, "45")
          this.warnList = []
          if (res.content.list) {
            res.content.list.forEach((item) => {
              item.alarmTime = item.alarmTime.substring(0, 10)
              item.alarmContent = item.alarmContent
            })
          }
          this.warnList =
            res.content == null
              ? []
              : res.content.list == null
              ? []
              : res.content.list
        }
      })
    },
    // 生日提醒
    getBirthday() {
      request({
        url: "/jjyl/admin/center/customer/info/findListAll",
        method: "POST",
        data: { birthday: this.dataTime, pageNo: 1, pageSize: -1 },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          // console.log(res, "45")
          this.birthdayList = []
          this.birthdayList = res.content.list
        } else {
          this.birthdayList = []
        }
      })
    },
    getPolice() {
      request({
        url: "ypt/admin/warningInfo/info/findList",
        method: "POST",
        data: { pageNo: 1, pageSize: -1 },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          // console.log(res, "45")
          this.policeList = []
          this.policeList = res.content.list
        } else {
          this.policeList = []
        }
      })
    },
    showDialog(row) {
      window.open(row.enclosure)
    },
    newPage() {
      this.$router.push({ name: "BookingABed" })
    },
    // 新建工单
    toAdd() {
      this.$router.push({ path: "/civilOrder1", query: { isIndex: 1 } })
    },
    //待派发
    toSend() {
      this.$router.push({ path: "/civilOrder1", query: { isIndex: 2 } })
    },
    // 待处理
    toOperate() {
      this.$router.push({ path: "/civilOrder2", query: { isIndex: 1 } })
    },
    // 待回访
    toVisited() {
      this.$router.push({ path: "/civilOrder3", query: { isIndex: 1 } })
    },
    toDel() {
      this.$router.push({ path: "/civilOrder4", query: { isIndex: 1 } })
    },
    // 跳转到质检回访
    toTraject() {
      this.$router.push({
        path: "/trajectoryVisit",
        query: { isIndex: 1 },
      })
    },
    // 打电话
    callPhone1(row) {
      this.$http
                        .request({
                            url: "/jjyl/admin/msg/sendMsg",
                            method: "POST",
                            data: {
                                templateCode:'SMS_273760389',
                                customerId: row.id,
                                phone:row.phone,
                                sendMsgParamDTO: {
                                  name:row.customerName
                                }
                            },
                        })
                        .then((res) => {
                            if (res.code === 200) {
                                if (res.content != null) {
                                    this.$message.success('发送成功')
                                    this.getBirthday()
                                }
                            }
                        })
    },
    aa(){
       request({
        url: "/jjyl/admin/communicationType/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 1000,
          status: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (!res.content) {
            this.$message.warning(
              "请先数据字典栏目下沟通类型菜单里去创建或开启生日祝福"
            )
          } else {
            if (res.content.list.length > 0) {
              let state = res.content.list.find((item) => {
                return item.name == "生日祝福"
              })
              // console.log(state, "祝福数据")
              if (state == undefined) {
                this.$message.warning(
                  "请先数据字典栏目下沟通类型菜单里去创建或开启生日祝福"
                )
              } else {
                this.$store.dispatch("setPhone", row)
                exportVue.$emit("importantInfo", true)
                sessionStorage.setItem("phoneStart", String(state.id))
              }
            } else {
              this.$message.warning(
                "请先数据字典栏目下沟通类型菜单里去创建或开启生日祝福"
              )
            }
          }
        }
      })
    },
    // 打电话
    callPhone(row) {
      this.$store.dispatch("setPhone", row)
      exportVue.$emit("importantInfo", true)
      sessionStorage.setItem("phoneStart", "1")
    },
    // 学习资料
    learnTap(num, name) {
      this.learnIndex = num
    //  this.getLearn(num)
    },
    //重要提醒
    majorTap(num) {
      this.majorIndex = num
      if (num == 0) {
        this.birdayState = true
        sessionStorage.setItem("homeBirth", "1")
        this.birthdayList = []
        this.getBirthday()
      } else if (num == 1) {
        sessionStorage.setItem("homePolice", "1")
        this.policeState = true
        this.policeList = []
        this.getPolice()
      } else if (num == 2) {
        sessionStorage.setItem("homeWarn", "1")
        this.healState = true
        this.trajectList = []
        this.warnList = []
        this.getWarn()
      } else if (num == 3) {
        sessionStorage.setItem("homeTraject", "1")
        this.trajectList = []
        this.getTraject()
        this.visiteState = true
      } else {
        sessionStorage.setItem("homeEquip", "1")
        this.equipState = true
        this.equipList = []
        this.getEquip()
      }
      if (this.birthdayList.length == 0) {
        this.birdayState = true
      }
      if (this.warnList.length == 0) {
        this.healState = true
      }
      if (this.policeList.length == 0) {
        this.policeState = true
      }
      if (this.trajectList.length == 0) {
        this.visiteState = true
      }
      if (this.equipList.length == 0) {
        this.equipState = true
      }
      if (
        this.equipState == true &&
        this.visiteState == true &&
        this.birdayState == true &&
        this.healState == true &&
        this.policeState == true
      ) {
        this.allState = true
      }
    },
    // 呼入量
    inCallTap() {
      if (this.isInCall == false) {
        this.getTarget(0)
      } else {
        this.isInCall = !this.isInCall
      }
    },
    // 呼出量
    outCallTap() {
      if (this.isOutCall == false) {
        this.getTarget(1)
      } else {
        this.isOutCall = !this.isOutCall
      }
    },
    // 通话记录
    recondTap() {
      if (this.isRecond == false) {
        this.getTarget(2)
      } else {
        this.isRecond = !this.isRecond
      }
    },
    // 派发工单
    sendTap() {
      if (this.isSend == false) {
        this.getTarget(3)
      } else {
        this.isSend = !this.isSend
      }
    },
    // 回访量
    visitedTap() {
      if (this.isVisited == false) {
        this.getTarget(4)
      } else {
        this.isVisited = !this.isVisited
      }
    },
    // 个人情况
    personTap(index) {
      this.peronIndex = index
      this.$http
        .request({
          url: "/jjyl/callInfo/info/statistics",
          method: "POST",
          data: {
            flag: index,
            agentId: this.$store.state.seatNo,
            dataId: JSON.parse(localStorage.getItem("czUserInfo")).dataId,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.statisData = res.content
          }
        })
    },
    // 今日目标信息
    getTarget(obj) {
      this.$http
        .request({
          url: "/jjyl/todayGoal/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: -1,
            orgId: this.$store.state.info.orgId,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content) {
              let content = res.content.list[0]
              this.targetInfo = {
                callIn: content.callIn,
                callOut: content.callOut,
                callLog: content.callLog,
                handOut: content.handOut,
                retrunVisit: content.retrunVisit,
              }
            } else {
              this.targetInfo = {
                callIn: 0,
                callOut: 0,
                callLog: 0,
                handOut: 0,
                retrunVisit: 0,
              }
            }
            if (obj == 0) {
              this.isInCall = true
              this.isOutCall = false
              this.isRecond = false
              this.isSend = false
              this.isVisited = false
            } else if (obj == 1) {
              this.isInCall = false
              this.isRecond = false
              this.isSend = false
              this.isVisited = false
              this.isOutCall = true
            } else if (obj == 2) {
              this.isInCall = false
              this.isOutCall = false
              this.isSend = false
              this.isVisited = false
              this.isRecond = true
            } else if (obj == 3) {
              this.isInCall = false
              this.isOutCall = false
              this.isRecond = false
              this.isVisited = false
              this.isSend = true
            } else if (obj == 4) {
              this.isInCall = false
              this.isOutCall = false
              this.isRecond = false
              this.isSend = false
              this.isVisited = true
            }
            // console.log(this.isInCall,'csss',this.targetInfo)
          }
        })
    },
    // 分页
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.getRank()
    },
    // 搜索姓名
    search() {
      this.page.pageSize = 1
      this.getRank()
    },
    //  查看排名
    getRank() {},
    // 关闭详情
    closeDialog() {
      this.maskState = false
    },
    // 排名切换
    maksTap(num) {
      this.openNum = num
      this.maskState = true
    },

    // 获取工单统计
    getGongDan() {
      const self = this
      request({
        url: "/jjyl/servicePgd/info/findPgdStateCount",
        method: "POST",
        data: {},
      }).then((res) => {
        if (res.code === 200 && res.content) {
          // console.log(res, "45")
          res.content.forEach((item) => {
            if (item.states == 0) {
              self.workNum.sendNum = item.pgdTotal
            } else if (item.states == 1) {
              self.workNum.handleNum = item.pgdTotal
            } else if (item.states == 2) {
              self.workNum.visiteNum = item.pgdTotal
            } else if (item.states == 4) {
              self.workNum.delNum = item.pgdTotal
            } else if (item.states == 8) {
              self.workNum.netNum = item.pgdTotal
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.box {
  display: flex;
  justify-content: space-between;

  & > div {
    width: 49%;
  }
}
.active-text {
  color: #038ef3;
}

.cus-1 {
  width: 100%;
  height: 300px;
  justify-content: space-between;
}

.bottom-1 {
  width: 100%;
  display: flex;
  margin-top: 20px;
  height: 400px;
  justify-content: space-between;
}

.bottom-1 > div:first-child {
  width: 48%;
  box-shadow: 0px 0px 10px #e6e6e6;
  border-radius: 8px;
}

.bottom-1 > div:nth-child(2) {
  width: 50%;
  box-shadow: 0px 0px 10px #e6e6e6;
  border-radius: 8px;
}

.query {
  margin-bottom: 20px;

  .queryInput {
    width: 200px;
    margin-right: 15px;
  }
}

.pagination_container {
  margin-top: 15px;
}

// 工单处置
.orderMain {
  .orderTitle {
    padding: 20px 20px 0 20px;
    color: #474747;
    font-size: 16px;
  }

  .orderBox {
    display: flex;
    justify-content: space-between;

    .orderItem {
      flex: 1;
      height: 100px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      cursor: pointer;
      background: rgba(255, 255, 255, 0.98);

      .imgs {
        width: 20%;
        // height: 40%;
        margin: 0 20px;
      }

      .content {
        flex: 1;
        color: #666666;

        .name {
          font-size: 14px;
        }

        .nameBig {
          font-size: 18px;
          // padding-top: 13px;
        }

        .nums {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 20px;
        }
      }
    }

    .orderItem:not(:first-child) {
      margin-left: 15px;
      margin-bottom: 15px;
    }
  }
}

// 个人工作总结
.operationBox {
  background: #fff;
  padding: 15px;
  border-radius: 16px;

  .operateTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > span {
      font-size: 18px;
      font-weight: 600;
      color: #333330;
    }

    .operateChoose {
      text-align: right;
      color: #474747;
      font-size: 14px;
      line-height: 30px;

      span {
        cursor: pointer;
        margin-right: 20px;
      }
    }
  }

  .operationMain {
    .operaContent {
      height: 343px;
      overflow: auto;
    }

    .operaItem {
      height: 53px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      background: #e7f1ff;
      color: #666666;

      .img {
        width: 40px;
        height: 40px;
        margin-left: 20px;
      }

      .name {
        width: 120px;
        padding-left: 30px;
      }

      .nums {
        padding-left: 20px;
        width: 120px;
        text-align: center;
      }

      .seeInfo {
        cursor: pointer;
        color: #e95c7a;
      }

      .see {
        flex: 1;
        text-align: right;
        padding: 0 20px;
        // .seeName{color: ;}
        .tip {
          text-align: left;
          color: #474747;
          width: 70px;
          display: inline-block;
        }

        .tips {
          text-align: left;
          width: 70px;
          color: #ff4040;
          display: inline-block;
        }

        .seeShow {
          width: 15px;
          height: 15px;
          cursor: pointer;
          margin-left: 10px;
        }

        .seeHide {
          width: 15px;
          height: 15px;
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }
    .operaHeader {
      background: #3875ff;
      color: #fff;
      margin-top: 15px;

      .see {
        text-align: center;
      }
    }
  }
}

// 重要提醒
.majorMain {
  padding: 15px;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 16px;

  .majorTitle {
    color: #474747;
    font-size: 16px;

    span {
      position: relative;
      font-size: 18px;
      font-weight: 600;
      color: #333330;

      i {
        position: absolute;
        right: -4px;
        top: 0px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #ff2c2c;
      }
    }
  }

  .majorBox {
    display: flex;
    justify-content: space-between;

    .majorUl {
      display: flex;
      .majorLi {
        border-radius: 4px;
        font-size: 12px;
        padding: 5px 10px;
        cursor: pointer;
        background: #f1f5ff;
        margin-left: 10px;
        color: #7587c5;

        .name {
          position: relative;

          .dot {
            width: 30px;
            height: 30px;
            font-size: 12px;
            color: #fff;
            text-align: center;
            background: #ff3d3d;
            line-height: 20px;
            position: absolute;
            right: -24px;
            top: 0px;
            border-radius: 50%;
          }
        }

        &.cur {
          background: #3875ff;
          color: #fff;
        }
      }
    }
  }
  .majorRight {
    height: 637px;
    overflow: hidden;
    margin-top: 20px;
  }
}

.callPhone {
  cursor: pointer;
  width:20px;
}

.operation-color {
  cursor: pointer;
}

/deep/ .el-table {
  th {
    color: #666666 !important;
    background: #f1f5ff !important;
    font-weight: 500;
  }
}
</style>
